<template>
    <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type'), $t('TradingAccount.box-name')]">
        <page-navigate></page-navigate>
        <section class="flex trading-account_header ">
            <div class="trading-account_main ">
                <h1 class="trading-account_title super_large-80_bold md-title-32_bold word1">
                    交易账号
                </h1>
                <h2 class="trading-account_desc subtitle-20_regular md-body-14_regular word2">
                    多样化交易账号类型，契合各类投资者需求，以灵活机制与极速体验，助您畅行交易之旅
                </h2>
                <a :href="signupUrl" target="_blank">
                    <div class="trading-account_btn primary-default_large cursor-pointer">
                        <span class="word3">立即开户</span>
                        <span class="iconfont icon-right"></span>
                    </div>
                </a>
            </div>
            <img src="@/assets/image/trading-account/container1Model.png" alt="" class="trading-account_model" />
        </section>
        <section class="trading-account_type">
            <h2 class="account-type_title title-48_bold md-title-24_bold text-center word18 scroll-fade-up ">
                账号类型
            </h2>
            <h3
                class="account-type_desc subtitle-20_regular md-footnote-regular_12 text-center word19 scroll-fade-up scroll-fade-up">
                各账号类型的主要差异，助您选择适合您交易策略的账号
            </h3>
            <div class="swiper account-type-swiper">
                <div class="flex account-type_cardList swiper-wrapper">
                    <div class="account-type_card swiper-slide scroll-fade-left">
                        <div class="account-type_cardMain flex justify-between items-center">
                            <div>
                                <div class="account-type_cardTitle title-24_bold md-body-16_medium word6">
                                    标准账号
                                </div>
                                <div class="account-type_cardDesc body-16_regular md-footnote-regular_12 word8">
                                    适合全部投资者和轻资本交易者
                                </div>
                            </div>
                            <img class="account-type_cardLogo" src="@/assets/image/trading-account/container2LogoL.png"
                                alt="" />
                        </div>
                        <div class="account-type_cardIntroList">
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word21">
                                    最低点差
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">1.1</span>
                                    pips
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word22">
                                    手续费
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">0</span>
                                    USD/lot
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word23">
                                    挂单距离限制
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">5</span>
                                    pips
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word24">
                                    最大杠杆
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    500:1
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word25">
                                    最小单笔交易量
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">0.01</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word26">
                                    最大单笔交易量
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">40</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word27">
                                    爆仓比例
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">30%</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word28">
                                    允许锁仓
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word29">
                                    EA 兼容性
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word30">
                                    24/7 在线支持
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word31">
                                    专属客户经理
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <a :href="signupUrl" target="_blank">
                                <div class="primary-default_large account-type_cardBtn cursor-pointer word33">
                                    开设标准账号
                                    <span class="iconfont icon-right"></span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="account-type_card swiper-slide scroll-fade-right ">
                        <div class="account-type_cardMain flex justify-between items-center">
                            <div>
                                <div class="account-type_cardTitle title-24_bold md-body-16_medium word7">
                                    专业账号
                                </div>
                                <div class="account-type_cardDesc body-16_regular md-footnote-regular_12 word14">
                                    适合专业投资者和进阶交易者
                                </div>
                            </div>
                            <img class="account-type_cardLogo" src="@/assets/image/trading-account/container2LogoR.png"
                                alt="" />
                        </div>
                        <div class="account-type_cardIntroList">
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word21">
                                    最低点差
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">0.0</span>
                                    pips
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word22">
                                    手续费
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">6</span>
                                    USD/lot
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word23">
                                    挂单距离限制
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <span class="md-body-14_medium">0</span>
                                    pips
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word24">
                                    最大杠杆
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    500:1
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word25">
                                    最小单笔交易量
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">0.01</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word26">
                                    最大单笔交易量
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">40</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word27">
                                    爆仓比例
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">30%</div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word28">
                                    允许锁仓
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word29">
                                    EA 兼容性
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word30">
                                    24/7 在线支持
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <div class="account-type_cardIntroItem">
                                <div class="account-type_cardIntroName body-16_regular md-footnote-regular_12 word31">
                                    专属客户经理
                                </div>
                                <div class="account-type_cardIntroVal body-16_medium md-body-14_medium">
                                    <img class="account-type_cardCheckBox"
                                        src="@/assets/image/trading-account/container2CheckBox.svg" alt="" />
                                </div>
                            </div>
                            <a :href="signupUrl" target="_blank">
                                <div class="primary-default_large account-type_cardBtn cursor-pointer word34">
                                    开设专业账号
                                    <span class="iconfont icon-right"></span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
        <section class="ebc-advan">
            <h2 class="ebc-advan_title title-48_bold md-title-24_bold text-center word35 scroll-fade-up">
                EBC 优势
            </h2>
            <h3 class="ebc-advan_desc subtitle-20_regular md-footnote-regular_12 text-center word36 scroll-fade-up">
                无论您选择标准账号还是专业账号，均可享受到平台核心优势
            </h3>
            <div class="ebc-advan_dataContent">
                <div class="ebc-advan_dataList flex flex-wrap scroll-fade-left">
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            <span id="number1">1000</span>
                            <span class="ebc-advan_dataValUnit md-body-14_medium word37">+</span>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word38">
                            每秒最高聚合订单
                        </div>
                    </div>
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            <span id="number2">98.75</span>
                            <span class="ebc-advan_dataValUnit md-body-14_medium">%</span>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word40">
                            数据传输稳定性高达
                        </div>
                    </div>
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            &lt;
                            <div id="number3">20</div>
                            <span class="ebc-advan_dataValUnit md-body-14_medium">ms</span>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word39">
                            平均执行速度
                        </div>
                    </div>
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            <div id="number4">25</div>
                            <span class="ebc-advan_dataValUnit md-body-14_medium">+</span>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word41">
                            对接国际顶级银行和对冲基金
                        </div>
                    </div>
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            <div id="number5">0.0</div>
                            <span class="ebc-advan_dataValUnit md-body-14_medium">pips</span>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word44">
                            同业银行级别的 RAW ECN 点差
                        </div>
                    </div>
                    <div class="ebc-advan_dataItem">
                        <div class="ebc-advan_dataVal flex items-start md-title-24_bold">
                            <div id="number6">24</div>
                            /
                            <div id="number7">7</div>
                        </div>
                        <div class="body-14_regular md-footnote-regular_12 ebc-advan_dataDesc word42">
                            VIP尊享服务
                        </div>
                    </div>
                </div>
                <img src="@/assets/image/trading-account/container3Model.png" alt=""
                    class="ebc-advan_dataImg scroll-fade-right" />
            </div>
        </section>
        <open-account></open-account>
        <section class="dl-tradPlatform">
            <div class="maxPage">
                <h2 class="title-48_bold md-title-24_bold word54 scroll-fade-up">下载交易平台</h2>
                <h3 class="dl-tradPlatform_desc subtitle-20_regular md-footnote-regular_12 word55 scroll-fade-up">
                    MT4/MT5
                    是全球顶尖的外汇交易平台，以其卓越的图表工具、丰富的技术指标和自动交易功能著称。无论您使用
                    PC 端深入分析、手机端即时交易，还是网页端实时监控，MT4/MT5
                    都能确保您享受到流畅灵活的交易体验。
                </h3>
                <div class="dl-tradPlatform-cardList flex justify-center flex-wrap">
                    <div class="dl-tradPlatform-card scroll-fade-left">
                        <img src="@/assets/image/trading-account/container5L.png" alt="" />
                        <a href="/MT4" class="primary-default_large box-border cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                fill="none">
                                <path
                                    d="M19.3564 13.25C19.7707 13.25 20.1064 13.5858 20.1064 14V18C20.1064 18.4142 19.7707 18.75 19.3564 18.75H5.35645C4.94223 18.75 4.60645 18.4142 4.60645 18V14C4.60645 13.5858 4.94223 13.25 5.35645 13.25C5.77066 13.25 6.10645 13.5858 6.10645 14V17.25H18.6064V14C18.6064 13.5858 18.9422 13.25 19.3564 13.25Z"
                                    fill="white" />
                                <path
                                    d="M12.3564 4.75C12.7707 4.75 13.1064 5.08579 13.1064 5.5V12.6665L15.3213 10.4121C15.6115 10.1167 16.0863 10.1122 16.3818 10.4023C16.6772 10.6926 16.6817 11.1674 16.3916 11.4629L12.8916 15.0254C12.7506 15.1689 12.5577 15.25 12.3564 15.25C12.1552 15.25 11.9623 15.1689 11.8213 15.0254L8.32129 11.4629C8.03119 11.1674 8.03565 10.6926 8.33105 10.4023C8.62654 10.1122 9.10137 10.1167 9.3916 10.4121L11.6064 12.6665V5.5C11.6064 5.08579 11.9422 4.75 12.3564 4.75Z"
                                    fill="white" />
                            </svg>
                            <span class="word56">MT4下载</span> </a>
                    </div>
                    <div class="dl-tradPlatform-card scroll-fade-right">
                        <img src="@/assets/image/trading-account/container5R.png" alt="" />
                        <a href="/MT5" class="primary-default_large box-border cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                fill="none">
                                <path
                                    d="M19.3564 13.25C19.7707 13.25 20.1064 13.5858 20.1064 14V18C20.1064 18.4142 19.7707 18.75 19.3564 18.75H5.35645C4.94223 18.75 4.60645 18.4142 4.60645 18V14C4.60645 13.5858 4.94223 13.25 5.35645 13.25C5.77066 13.25 6.10645 13.5858 6.10645 14V17.25H18.6064V14C18.6064 13.5858 18.9422 13.25 19.3564 13.25Z"
                                    fill="white" />
                                <path
                                    d="M12.3564 4.75C12.7707 4.75 13.1064 5.08579 13.1064 5.5V12.6665L15.3213 10.4121C15.6115 10.1167 16.0863 10.1122 16.3818 10.4023C16.6772 10.6926 16.6817 11.1674 16.3916 11.4629L12.8916 15.0254C12.7506 15.1689 12.5577 15.25 12.3564 15.25C12.1552 15.25 11.9623 15.1689 11.8213 15.0254L8.32129 11.4629C8.03119 11.1674 8.03565 10.6926 8.33105 10.4023C8.62654 10.1122 9.10137 10.1167 9.3916 10.4121L11.6064 12.6665V5.5C11.6064 5.08579 11.9422 4.75 12.3564 4.75Z"
                                    fill="white" />
                            </svg>
                            <span class="word57">MT5下载</span> </a>
                    </div>
                </div>
            </div>
        </section>


        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from "vuex";

export default {
    mixins: [fadeAnimate],
    data() {
        return {
            khUrl: 'https://client.ebc-pro.com/signup?bid=5s71xp',
            mnUrl: 'https://client.ebccrm.com/simulation',
            seoInfo: ""
        }
    },
    metaInfo() {
        return {
            title: this.seoInfo.title || '',
            meta: [ // set meta
                {
                    name: 'keyWords',
                    content: this.seoInfo.keyWords || ''
                },
                {
                    name: 'description',
                    content: this.seoInfo.description || ''
                }
            ]
        }
    },
    created() {
        this.$getSeoInfo({
            lang: this.$t("common.requestLang"),//this.$store.state.Lan,
            path: "/TradingAccount"
        }).then(res => {
            this.seoInfo = res
        })
        let par = localStorage.getItem('advert')
        let lang = localStorage.getItem('language')
        let parms;
        if (lang === 'ct') {
            parms = 'tw'
        } else if (lang === 'ja') {
            parms = 'jp'
        } else if (lang === 'vi') {
            parms = 'zh'
        } else {
            parms = lang
        }
        par = JSON.parse(par)
        if (par != null) {
            this.khUrl = this.khUrl + '?utm_source=' + par.utm_source + '&utm_medium=' + par.utm_medium +
                '&utm_campaign=' + par.utm_campaign + '&utm_term=' + par.utm_term + '&utm_content=' + par.utm_content +
                '&hl=' + parms
        } else {
            this.khUrl = this.khUrl + '?hl=' + parms
        }
        this.mnUrl = this.mnUrl + '?hl=' + parms
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {
            
            function numberAnimate() {
                const cfg = {
                    1: [1000, 0],
                    2: [98.75, 0],
                    3: [20, 0],
                    4: [25, 0],
                    5: [0, 1, "0.0"],
                    6: [24, 0],
                    7: [7, 0],
                };

                Object.keys(cfg).forEach((key) => {
                    const [end, decimals, prefix] = cfg[key];
                    const $el = $(`#number${key}`);
                    $({ countNum: decimals === 1 ? 60 : 0 }).animate(
                        { countNum: end },
                        {
                            duration: 700,
                            easing: "linear",
                            step() {
                                const val =
                                    decimals > 0
                                        ? (this.countNum / 10).toFixed(1)
                                        : Math.floor(this.countNum);
                                $el.eq(0).text(val);
                            },
                            complete() {
                                const final = decimals > 0 ? prefix : end;
                                $el.eq(0).text(final);
                            },
                        }
                    );
                });
            }
            const numberAm = new IntersectionObserver((entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        numberAnimate();
                        numberAm.unobserve(e.target);
                    }
                });
            });
            numberAm.observe(document.querySelector(".ebc-advan_dataList"));
        }
    },
    computed: {
        ...mapGetters(["signupUrl"]),
    },
}
</script>
<style scoped>
a:hover {
    color: #fff;
}

.contentBox,
.maxPage {
    max-width: 1200rem;
    margin-inline: auto;
}

.openAccountPart .btn {
    gap: 4rem;
    min-width: 180rem;
    width: fit-content;
    cursor: pointer;
}

.trading-account_header {
    background: #ebebeb;
    padding-top: 77rem;
    min-height: 560rem;
    gap: 127rem;
    padding-left: calc(50vw - 600rem);
    position: relative;
}

.trading-account_main {
    padding-top: 83rem;
    flex: 0 0 588rem;
}

.trading-account_title {}

.trading-account_desc {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 64rem;
}

.trading-account_btn {
    width: fit-content;
    min-width: 180rem;
}

.openAccountPart a {
    display: block;
    width: fit-content;
    margin-inline: auto;
}

.trading-account_main a {
    width: fit-content;
    display: inline-block;
}

.trading-account_model {
     height: 100%;
  position: absolute;
  left: calc(468rem + 50vw - 600rem);
  top: 0;
}

.icon-right {
    display: inline-block;
    margin-left: 5rem;
}

@media (min-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }


}

@media screen and (max-width: 996px) {
.trading-account_main a {
    width: 100%;
}
    section {
        padding-inline: 32rem !important;
    }

    .trading-account_header {
        flex-direction: column;
        gap: 0;
        align-items: center;
        padding-bottom: 80rem;
        padding-top: 562rem;
         overflow: hidden;
    }

    .trading-account_main {
        order: 2;
        text-align: center;
        padding-top: 30rem;
        flex-basis: unset;
    }

    .trading-account_model {
        min-width: 1214rem;
        height: 622rem;
        left: -265rem;
    }

    .trading-account_desc {
        margin: 16rem 0 108rem;
    }

    .trading-account_btn {
        width: 100%;
        gap: 8rem;
    }
}

.trading-account_type {
    padding: 80rem 0 120rem;
    background: #f7f7f7;
}

.account-type_desc {
    margin: 16rem 0 68rem;
    color: var(--ebc-text-secondary);
}

.account-type_cardList {
    justify-content: center;
    align-items: stretch;
    gap: 32rem;
}

.account-type_card {
    background: #fff;
    border-radius: 24rem;
    box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.4) inset;
    overflow: hidden;
    /* flex: 0 0 426rem; */
    width: 588rem !important;
    height: unset !important;

    display: flex;
    flex-direction: column;

}

.account-type_cardMain {
    padding: 32rem 38rem 32rem 32rem;
    background: #e8e8e8;
    flex: 1;
    gap: 15rem;
}

.account-type_cardDesc {
    margin-top: 8rem;
    color: var(--ebc-text-secondary);
}

.account-type_cardIntroList {
    padding: 20rem 32rem 32rem;
}

.account-type_cardIntroItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24rem;
}

.account-type_cardIntroName {
    color: var(--ebc-text-tertiary);
}

.account-type_cardIntroName {
    flex: 0 0 160rem;
}

.account-type_cardLogo {
    width: 108rem;
}

.account-type_cardIntroItem:nth-child(-n + 2) {
    margin-bottom: 16rem;

}



.account-type_cardIntroItem:nth-child(3) {
    margin-bottom: 16rem;
}

.account-type_cardIntroItem:nth-child(n + 4) {
    margin-bottom: 16rem;
}

.account-type_cardBtn {
    margin-top: 24rem;
}

.account-type_cardCheckBox {
    width: 16rem;
}

@media screen and (max-width: 996px) {
    .trading-account_type {
        padding: 160rem 0 !important;
    }

    .account-type_title {
        padding-inline: 32rem;
    }

    .account-type_desc {
        padding-inline: 32rem;
        margin-bottom: 80rem;
    }

    .account-type_cardDesc {
        margin-top: 4rem;
    }

    .account-type_cardList {
        justify-content: flex-start;
        flex-direction: column;
        padding-inline: 32rem;
        box-sizing: border-box;
    }

    .account-type_card {
        /* flex: 0 0 640rem; */
        width: 100%!important;

    }

    .account-type_card:nth-child(1) {
        /* margin-left: 32rem; */
    }

    .account-type_cardMain {
        padding: 24rem 52rem 26rem 48rem;
    }

    .account-type_cardLogo {
        width: 118rem;
    }

    .account-type_cardIntroList {
        padding: 32rem 48rem;
    }

    .account-type_cardIntroList .account-type_cardIntroItem {
        margin-bottom: 20rem;
        justify-content: space-between;
        margin-bottom: 16rem;
    }



    .account-type_cardIntroItem:nth-child(3) {
        margin-bottom: 16rem;
    }

    .account-type_cardIntroItem:nth-child(n + 8),
    .account-type_cardIntroItem:nth-child(-n + 3) {
        /* height: 40rem; */
    }

    .account-type_cardIntroItem:nth-child(-n + 3) .account-type_cardIntroVal {
        font-size: 16rem;
        line-height: 24rem;
    }

    .account-type_cardIntroItem .account-type_cardIntroVal {
        font-size: 28rem;
        line-height: 44rem;
    }

    .account-type_cardIntroName {
        flex: 1;
    }

    .account-type_cardCheckBox {
        width: 28rem;
    }

    .account-type_cardIntroList .account-type_cardBtn {
        margin-top: 32rem;
        height: 80rem;
        font-size: 28rem;
        line-height: 44rem;
        gap: 8rem;
    }

    .account-type-swiperPagenation {
        display: none;
        gap: 16rem;
        margin-top: 80rem;
        padding: 16rem 0;
    }

    .account-type-swiperPagenation div {
        border-radius: 999px;
        opacity: 0.5;
        background: var(--ebc-basecolor-active-100);
        width: 12px;
        height: 2px;
    }

    .account-type-swiperPagenation div.active {
        opacity: 1;
        width: 24px;
        background: var(--ebc-basecolor-active-500);
    }
}

.ebc-advan {
    padding: 120rem 0 190rem;
    background: #fff;
    overflow: hidden;
}

.ebc-advan h2,
.ebc-advan h3 {
    max-width: 1200rem;
    margin-inline: auto;
    position: relative;
    z-index: 2;
}

.ebc-advan_desc {
    color: var(--ebc-text-secondary);
    margin: 16rem auto 82rem;
}

.ebc-advan_dataContent {
    position: relative;
    /* max-width: 1200rem; */
    margin-left: calc(50vw - 600rem);
    z-index: 1;
}

.ebc-advan_dataList {
    gap: 48rem;
    max-width: 500rem;
    align-items: unset;
}

.ebc-advan_dataItem {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding-bottom: 12rem;
    flex: 0 0 220rem;
}

.ebc-advan_dataVal {
    color: var(--ebc-brand-secondary-red);
    font-size: 40rem;
    font-weight: 700;
    line-height: 56rem;
    /* 140% */
    gap: 4rem;
}

@media (min-width: 996px) {
    .ebc-advan_dataValUnit {
        font-size: 20rem;
        line-height: 22rem;
        padding-top: 8rem;
    }
}


.ebc-advan_dataDesc {
    color: var(--ebc-text-secondary);
}

.ebc-advan_dataImg {
    position: absolute;
    top: -72rem;
    left: -15rem;
    width: 1559rem;
    height: 633rem;
    z-index: -1;
}

@media screen and (max-width: 996px) {
  .ebc-advan_dataValUnit{
    padding-top: 0;
  }
    .ebc-advan {
        padding: 160rem 32rem 720rem;
    }

    .ebc-advan_desc {
        margin: 16rem 0 80rem;
    }

    .ebc-advan_dataList {
        gap: 64rem 48rem;
        max-width: 100%;
    }

    .ebc-advan_dataItem {
        padding-bottom: 8rem;
        flex: 0 0 313rem;
    }

    .ebc-advan_dataDesc {
        margin-top: 8rem;
    }

    .ebc-advan_dataVal {
        gap: 8rem;
        align-items: center;
    }
    .ebc-advan_dataContent{
        margin-inline: auto;
    }
    .ebc-advan_dataImg {
        position: absolute;
        height: 665rem;
        top: unset;
        bottom: -720rem;
        left: -575rem;
        max-width: unset;
    }
}

.dl-tradPlatform {
    background: #fff;
    text-align: center;
    padding: 80rem 0 120rem;
}

.dl-tradPlatform_desc {
    margin: 16rem 0 80rem;
    color: var(--ebc-text-secondary);
}

.dl-tradPlatform-cardList {
    gap: 48rem;
}

.dl-tradPlatform-card {
    border-radius: var(--ebc-corner-radius-rc16);
    background: #f7f7f7;
    padding: 44rem 0 47rem;
    flex: 0 0 474rem;
}

.dl-tradPlatform-card img {
    width: 263rem;
    margin-bottom: 51rem;
}

.dl-tradPlatform-card a {
    min-width: 180rem;
    width: fit-content;
    gap: 8rem;
    margin-inline: auto;
}

.dl-tradPlatform-card a svg {
    width: 24rem;
    height: 24rem;
}

@media screen and (max-width: 996px) {
    .dl-tradPlatform {
        padding: 160rem 32rem;
    }

    .dl-tradPlatform_desc {
        margin: 16rem 0 80rem;
    }

    .dl-tradPlatform-card {
        flex: 0 0 100%;
        border-radius: 32rem;
    }

    .dl-tradPlatform-card img {
        width: 390rem;
        margin-bottom: 48rem;
    }

    .dl-tradPlatform-card a {
        min-width: 320rem;
        height: 80rem;
        font-size: 28rem;
    }

    .dl-tradPlatform-card a svg {
        width: 48rem;
        height: 48rem;
    }
}
</style>